import sample from 'lodash/sample'
import { BSC_RCP_ENDPOINTS } from 'constants/config'

// Array of available nodes to connect to
export const nodes = BSC_RCP_ENDPOINTS.split(',')

const getNodeUrl = () => {
  return sample(nodes)
}

export default getNodeUrl
